import React from 'react';

const RecordingIcon = ({ state }) => {
    return (
        <span
            className={`w-8 h-8 mr-3 flex items-center justify-center transistion-all ${
                state === 'STOPPED'
                    ? 'bg-black'
                    : state === 'PAUSED'
                    ? 'bg-black rounded-full'
                    : 'bg-red-800 rounded-full'
            }`}
        >
            {state === 'PAUSED' && (
                <span className="font-12/18 text-white font-PoppinsSemi tracking-widest">||</span>
            )}
        </span>
    );
};

export default RecordingIcon;
